import { MantineColorsTuple, lighten } from "@mantine/core";

// https://mantine.dev/colors-generator/

export const advizeBlue: MantineColorsTuple = [
  "#ecf4fd",
  "#d7e4f6",
  "#aac7ee",
  "#7ca8e8",
  "#568ee3",
  "#407de1",
  "#3575e0",
  "#2963c8",
  "#2058b3",
  "#0e4692",
];

export const advizeGreen: MantineColorsTuple = [
  "#e2fff7",
  "#cefeef",
  "#a0fbdd",
  "#6ef9cb",
  "#46f6bc",
  "#2ef6b2",
  "#1df5ac",
  "#09da96",
  "#00c184",
  "#00a770",
];

export const slate: MantineColorsTuple = [
  "#fff",
  "#f8fafc",
  "#f1f5f9",
  "#e2e8f0",
  "#cbd5e1",
  "#94a3b8",
  "#64748b",
  "#475569",
  "#334155",
  "#1e293b",
  "#0f172a",
];

export const advizeDarkGreen: MantineColorsTuple = [
  "#eef9f3",
  "#e3ece7",
  "#c6d5ce",
  "#a8beb2",
  "#8dab9b",
  "#7c9f8c",
  "#729983",
  "#608571",
  "#537763",
  "#426754",
];

export const highlightYellow: MantineColorsTuple = [
  "#fff8e1",
  "#ffe9b4",
  "#ffda82",
  "#ffcc4d",
  "#ffbd1d",
  "#ffae00",
  "#e69500",
  "#cc8000",
  "#b36b00",
  "#995600",
  "#804200",
];

const sacStateGreenBase = "#043927";
export const sacStateGreen: MantineColorsTuple = [
  lighten(sacStateGreenBase, 0.9),
  lighten(sacStateGreenBase, 0.8),
  lighten(sacStateGreenBase, 0.7),
  lighten(sacStateGreenBase, 0.6),
  lighten(sacStateGreenBase, 0.5),
  lighten(sacStateGreenBase, 0.4),
  lighten(sacStateGreenBase, 0.3),
  lighten(sacStateGreenBase, 0.2),
  lighten(sacStateGreenBase, 0.1),
  sacStateGreenBase,
];

const sacStateGoldBase = "#78682d";
export const sacStateGold: MantineColorsTuple = [
  lighten(sacStateGoldBase, 0.9),
  lighten(sacStateGoldBase, 0.8),
  lighten(sacStateGoldBase, 0.7),
  lighten(sacStateGoldBase, 0.6),
  lighten(sacStateGoldBase, 0.5),
  lighten(sacStateGoldBase, 0.4),
  lighten(sacStateGoldBase, 0.3),
  lighten(sacStateGoldBase, 0.2),
  lighten(sacStateGoldBase, 0.1),
  sacStateGoldBase,
];

const asuMaroonBase = "#8C1D40";
export const asuMaroon: MantineColorsTuple = [
  lighten(asuMaroonBase, 0.9),
  lighten(asuMaroonBase, 0.8),
  lighten(asuMaroonBase, 0.7),
  lighten(asuMaroonBase, 0.6),
  lighten(asuMaroonBase, 0.5),
  lighten(asuMaroonBase, 0.4),
  lighten(asuMaroonBase, 0.3),
  lighten(asuMaroonBase, 0.2),
  lighten(asuMaroonBase, 0.1),
  asuMaroonBase,
];

export const asuGoldBase = "#FFC627";
export const asuGold: MantineColorsTuple = [
  lighten(asuGoldBase, 0.95),
  lighten(asuGoldBase, 0.9),
  lighten(asuGoldBase, 0.8),
  lighten(asuGoldBase, 0.6),
  lighten(asuGoldBase, 0.5),
  lighten(asuGoldBase, 0.4),
  lighten(asuGoldBase, 0.3),
  lighten(asuGoldBase, 0.2),
  lighten(asuGoldBase, 0.1),
  asuGoldBase,
];

export const allianceGreenBase = "#36A857";
export const allianceGreen: MantineColorsTuple = [
  lighten(allianceGreenBase, 0.9),
  lighten(allianceGreenBase, 0.8),
  lighten(allianceGreenBase, 0.7),
  lighten(allianceGreenBase, 0.6),
  lighten(allianceGreenBase, 0.5),
  lighten(allianceGreenBase, 0.4),
  lighten(allianceGreenBase, 0.3),
  lighten(allianceGreenBase, 0.2),
  lighten(allianceGreenBase, 0.1),
  allianceGreenBase,
];

export const allianceOrangeBase = "#3FC9E6";
export const allianceOrange: MantineColorsTuple = [
  lighten(allianceOrangeBase, 0.9),
  lighten(allianceOrangeBase, 0.8),
  lighten(allianceOrangeBase, 0.7),
  lighten(allianceOrangeBase, 0.6),
  lighten(allianceOrangeBase, 0.5),
  lighten(allianceOrangeBase, 0.4),
  lighten(allianceOrangeBase, 0.3),
  lighten(allianceOrangeBase, 0.2),
  lighten(allianceOrangeBase, 0.1),
  allianceOrangeBase,
];

export const californiaLutheranPrimaryBase = "#3b2360";
export const californiaLutheranPrimary: MantineColorsTuple = [
  lighten(californiaLutheranPrimaryBase, 0.9),
  lighten(californiaLutheranPrimaryBase, 0.8),
  lighten(californiaLutheranPrimaryBase, 0.7),
  lighten(californiaLutheranPrimaryBase, 0.6),
  lighten(californiaLutheranPrimaryBase, 0.5),
  lighten(californiaLutheranPrimaryBase, 0.4),
  lighten(californiaLutheranPrimaryBase, 0.3),
  lighten(californiaLutheranPrimaryBase, 0.2),
  lighten(californiaLutheranPrimaryBase, 0.1),
  californiaLutheranPrimaryBase,
];

export const californiaLutheranSecondaryBase = "#ffc222";
export const californiaLutheranSecondary: MantineColorsTuple = [
  lighten(californiaLutheranSecondaryBase, 0.9),
  lighten(californiaLutheranSecondaryBase, 0.8),
  lighten(californiaLutheranSecondaryBase, 0.7),
  lighten(californiaLutheranSecondaryBase, 0.6),
  lighten(californiaLutheranSecondaryBase, 0.5),
  lighten(californiaLutheranSecondaryBase, 0.4),
  lighten(californiaLutheranSecondaryBase, 0.3),
  lighten(californiaLutheranSecondaryBase, 0.2),
  lighten(californiaLutheranSecondaryBase, 0.1),
  californiaLutheranSecondaryBase,
];

export const compassDiversifiedPrimaryBase = "#0B2337";
export const compassDiversifiedPrimary: MantineColorsTuple = [
  lighten(compassDiversifiedPrimaryBase, 0.9),
  lighten(compassDiversifiedPrimaryBase, 0.8),
  lighten(compassDiversifiedPrimaryBase, 0.7),
  lighten(compassDiversifiedPrimaryBase, 0.6),
  lighten(compassDiversifiedPrimaryBase, 0.5),
  lighten(compassDiversifiedPrimaryBase, 0.4),
  lighten(compassDiversifiedPrimaryBase, 0.3),
  lighten(compassDiversifiedPrimaryBase, 0.2),
  lighten(compassDiversifiedPrimaryBase, 0.1),
  compassDiversifiedPrimaryBase,
];

export const compassDiversifiedSecondaryBase = "#DEB873";
export const compassDiversifiedSecondary: MantineColorsTuple = [
  lighten(compassDiversifiedSecondaryBase, 0.9),
  lighten(compassDiversifiedSecondaryBase, 0.8),
  lighten(compassDiversifiedSecondaryBase, 0.7),
  lighten(compassDiversifiedSecondaryBase, 0.6),
  lighten(compassDiversifiedSecondaryBase, 0.5),
  lighten(compassDiversifiedSecondaryBase, 0.4),
  lighten(compassDiversifiedSecondaryBase, 0.3),
  lighten(compassDiversifiedSecondaryBase, 0.2),
  lighten(compassDiversifiedSecondaryBase, 0.1),
  compassDiversifiedSecondaryBase,
];

export const hericansPrimaryBase = "#000";
export const hericansPrimary: MantineColorsTuple = [
  lighten(hericansPrimaryBase, 0.9),
  lighten(hericansPrimaryBase, 0.8),
  lighten(hericansPrimaryBase, 0.7),
  lighten(hericansPrimaryBase, 0.6),
  lighten(hericansPrimaryBase, 0.5),
  lighten(hericansPrimaryBase, 0.4),
  lighten(hericansPrimaryBase, 0.3),
  lighten(hericansPrimaryBase, 0.2),
  lighten(hericansPrimaryBase, 0.1),
  hericansPrimaryBase,
];

export const hericansSecondaryBase = "#00afff";
// export const hericansSecondaryBase = "#9341cb";
export const hericansSecondary: MantineColorsTuple = [
  lighten(hericansSecondaryBase, 0.9),
  lighten(hericansSecondaryBase, 0.8),
  lighten(hericansSecondaryBase, 0.7),
  lighten(hericansSecondaryBase, 0.6),
  lighten(hericansSecondaryBase, 0.5),
  lighten(hericansSecondaryBase, 0.4),
  lighten(hericansSecondaryBase, 0.3),
  lighten(hericansSecondaryBase, 0.2),
  lighten(hericansSecondaryBase, 0.1),
  hericansSecondaryBase,
];

export const mindsMatterPrimaryBase = "#191919";
export const mindsMatterPrimary: MantineColorsTuple = [
  lighten(mindsMatterPrimaryBase, 0.9),
  lighten(mindsMatterPrimaryBase, 0.8),
  lighten(mindsMatterPrimaryBase, 0.7),
  lighten(mindsMatterPrimaryBase, 0.6),
  lighten(mindsMatterPrimaryBase, 0.5),
  lighten(mindsMatterPrimaryBase, 0.4),
  lighten(mindsMatterPrimaryBase, 0.3),
  lighten(mindsMatterPrimaryBase, 0.2),
  lighten(mindsMatterPrimaryBase, 0.1),
  mindsMatterPrimaryBase,
];

export const mindsMatterSecondaryBase = "#00ADD8";
export const mindsMatterSecondary: MantineColorsTuple = [
  lighten(mindsMatterSecondaryBase, 0.9),
  lighten(mindsMatterSecondaryBase, 0.8),
  lighten(mindsMatterSecondaryBase, 0.7),
  lighten(mindsMatterSecondaryBase, 0.6),
  lighten(mindsMatterSecondaryBase, 0.5),
  lighten(mindsMatterSecondaryBase, 0.4),
  lighten(mindsMatterSecondaryBase, 0.3),
  lighten(mindsMatterSecondaryBase, 0.2),
  lighten(mindsMatterSecondaryBase, 0.1),
  mindsMatterSecondaryBase,
];

export const berkeleyPrimaryBase = "#002676";
export const berkeleyPrimary: MantineColorsTuple = [
  lighten(berkeleyPrimaryBase, 0.9),
  lighten(berkeleyPrimaryBase, 0.8),
  lighten(berkeleyPrimaryBase, 0.7),
  lighten(berkeleyPrimaryBase, 0.6),
  lighten(berkeleyPrimaryBase, 0.5),
  lighten(berkeleyPrimaryBase, 0.4),
  lighten(berkeleyPrimaryBase, 0.3),
  lighten(berkeleyPrimaryBase, 0.2),
  lighten(berkeleyPrimaryBase, 0.1),
  berkeleyPrimaryBase,
];

export const berkeleySecondaryBase = "#FDB515";
export const berkeleySecondary: MantineColorsTuple = [
  lighten(berkeleySecondaryBase, 0.9),
  lighten(berkeleySecondaryBase, 0.8),
  lighten(berkeleySecondaryBase, 0.7),
  lighten(berkeleySecondaryBase, 0.6),
  lighten(berkeleySecondaryBase, 0.5),
  lighten(berkeleySecondaryBase, 0.4),
  lighten(berkeleySecondaryBase, 0.3),
  lighten(berkeleySecondaryBase, 0.2),
  lighten(berkeleySecondaryBase, 0.1),
  berkeleySecondaryBase,
];

export const uclaAndersonPrimaryBase = "#2774AE";
export const uclaAndersonPrimary: MantineColorsTuple = [
  lighten(uclaAndersonPrimaryBase, 0.9),
  lighten(uclaAndersonPrimaryBase, 0.8),
  lighten(uclaAndersonPrimaryBase, 0.7),
  lighten(uclaAndersonPrimaryBase, 0.6),
  lighten(uclaAndersonPrimaryBase, 0.5),
  lighten(uclaAndersonPrimaryBase, 0.4),
  lighten(uclaAndersonPrimaryBase, 0.3),
  lighten(uclaAndersonPrimaryBase, 0.2),
  lighten(uclaAndersonPrimaryBase, 0.1),
  uclaAndersonPrimaryBase,
];

export const uclaAndersonSecondaryBase = "#FFD100";
export const uclaAndersonSecondary: MantineColorsTuple = [
  lighten(uclaAndersonSecondaryBase, 0.9),
  lighten(uclaAndersonSecondaryBase, 0.8),
  lighten(uclaAndersonSecondaryBase, 0.7),
  lighten(uclaAndersonSecondaryBase, 0.6),
  lighten(uclaAndersonSecondaryBase, 0.5),
  lighten(uclaAndersonSecondaryBase, 0.4),
  lighten(uclaAndersonSecondaryBase, 0.3),
  lighten(uclaAndersonSecondaryBase, 0.2),
  lighten(uclaAndersonSecondaryBase, 0.1),
  uclaAndersonSecondaryBase,
];

export const knaussPrimaryBase = "#00294e";
export const knaussPrimary: MantineColorsTuple = [
  lighten(knaussPrimaryBase, 0.9),
  lighten(knaussPrimaryBase, 0.8),
  lighten(knaussPrimaryBase, 0.7),
  lighten(knaussPrimaryBase, 0.6),
  lighten(knaussPrimaryBase, 0.5),
  lighten(knaussPrimaryBase, 0.4),
  lighten(knaussPrimaryBase, 0.3),
  lighten(knaussPrimaryBase, 0.2),
  lighten(knaussPrimaryBase, 0.1),
  knaussPrimaryBase,
];

export const knaussSecondaryBase = "#75bee9";
export const knaussSecondary: MantineColorsTuple = [
  lighten(knaussSecondaryBase, 0.9),
  lighten(knaussSecondaryBase, 0.8),
  lighten(knaussSecondaryBase, 0.7),
  lighten(knaussSecondaryBase, 0.6),
  lighten(knaussSecondaryBase, 0.5),
  lighten(knaussSecondaryBase, 0.4),
  lighten(knaussSecondaryBase, 0.3),
  lighten(knaussSecondaryBase, 0.2),
  lighten(knaussSecondaryBase, 0.1),
  knaussSecondaryBase,
];

export const stanfordPrimaryBase = "#820000";
export const stanfordPrimary: MantineColorsTuple = [
  lighten(stanfordPrimaryBase, 0.9),
  lighten(stanfordPrimaryBase, 0.8),
  lighten(stanfordPrimaryBase, 0.7),
  lighten(stanfordPrimaryBase, 0.6),
  lighten(stanfordPrimaryBase, 0.5),
  lighten(stanfordPrimaryBase, 0.4),
  lighten(stanfordPrimaryBase, 0.3),
  lighten(stanfordPrimaryBase, 0.2),
  lighten(stanfordPrimaryBase, 0.1),
  stanfordPrimaryBase,
];

export const stanfordSecondaryBase = "#2E2D29";
export const stanfordSecondary: MantineColorsTuple = [
  lighten(stanfordSecondaryBase, 0.9),
  lighten(stanfordSecondaryBase, 0.8),
  lighten(stanfordSecondaryBase, 0.7),
  lighten(stanfordSecondaryBase, 0.6),
  lighten(stanfordSecondaryBase, 0.5),
  lighten(stanfordSecondaryBase, 0.4),
  lighten(stanfordSecondaryBase, 0.3),
  lighten(stanfordSecondaryBase, 0.2),
  lighten(stanfordSecondaryBase, 0.1),
  stanfordSecondaryBase,
];

export const stanfordAccent1Base = "#D1660F";
export const stanfordAccent2Base = "#009AB4";
export const stanfordAccent3Base = "#620059";
export const stanfordAccent4Base = "#C74632";
export const stanfordAccent5Base = "#175E54";

export const stanfordAccent1: MantineColorsTuple = [
  lighten(stanfordAccent1Base, 0.9),
  lighten(stanfordAccent1Base, 0.8),
  lighten(stanfordAccent1Base, 0.7),
  lighten(stanfordAccent1Base, 0.6),
  lighten(stanfordAccent1Base, 0.5),
  lighten(stanfordAccent1Base, 0.4),
  lighten(stanfordAccent1Base, 0.3),
  lighten(stanfordAccent1Base, 0.2),
  lighten(stanfordAccent1Base, 0.1),
  stanfordAccent1Base,
];

export const stanfordAccent2: MantineColorsTuple = [
  lighten(stanfordAccent2Base, 0.9),
  lighten(stanfordAccent2Base, 0.8),
  lighten(stanfordAccent2Base, 0.7),
  lighten(stanfordAccent2Base, 0.6),
  lighten(stanfordAccent2Base, 0.5),
  lighten(stanfordAccent2Base, 0.4),
  lighten(stanfordAccent2Base, 0.3),
  lighten(stanfordAccent2Base, 0.2),
  lighten(stanfordAccent2Base, 0.1),
  stanfordAccent2Base,
];

export const stanfordAccent3: MantineColorsTuple = [
  lighten(stanfordAccent3Base, 0.9),
  lighten(stanfordAccent3Base, 0.8),
  lighten(stanfordAccent3Base, 0.7),
  lighten(stanfordAccent3Base, 0.6),
  lighten(stanfordAccent3Base, 0.5),
  lighten(stanfordAccent3Base, 0.4),
  lighten(stanfordAccent3Base, 0.3),
  lighten(stanfordAccent3Base, 0.2),
  lighten(stanfordAccent3Base, 0.1),
  stanfordAccent3Base,
];

export const stanfordAccent4: MantineColorsTuple = [
  lighten(stanfordAccent4Base, 0.9),
  lighten(stanfordAccent4Base, 0.8),
  lighten(stanfordAccent4Base, 0.7),
  lighten(stanfordAccent4Base, 0.6),
  lighten(stanfordAccent4Base, 0.5),
  lighten(stanfordAccent4Base, 0.4),
  lighten(stanfordAccent4Base, 0.3),
  lighten(stanfordAccent4Base, 0.2),
  lighten(stanfordAccent4Base, 0.1),
  stanfordAccent4Base,
];

export const stanfordAccent5: MantineColorsTuple = [
  lighten(stanfordAccent5Base, 0.9),
  lighten(stanfordAccent5Base, 0.8),
  lighten(stanfordAccent5Base, 0.7),
  lighten(stanfordAccent5Base, 0.6),
  lighten(stanfordAccent5Base, 0.5),
  lighten(stanfordAccent5Base, 0.4),
  lighten(stanfordAccent5Base, 0.3),
  lighten(stanfordAccent5Base, 0.2),
  lighten(stanfordAccent5Base, 0.1),
  stanfordAccent5Base,
];

export const uscaPrimaryBase = "#002855";
export const uscaPrimary: MantineColorsTuple = [
  lighten(uscaPrimaryBase, 0.9),
  lighten(uscaPrimaryBase, 0.8),
  lighten(uscaPrimaryBase, 0.7),
  lighten(uscaPrimaryBase, 0.6),
  lighten(uscaPrimaryBase, 0.5),
  lighten(uscaPrimaryBase, 0.4),
  lighten(uscaPrimaryBase, 0.3),
  lighten(uscaPrimaryBase, 0.2),
  lighten(uscaPrimaryBase, 0.1),
  uscaPrimaryBase,
];

export const uscaSecondaryBase = "#E4002B";
export const uscaSecondary: MantineColorsTuple = [
  lighten(uscaSecondaryBase, 0.9),
  lighten(uscaSecondaryBase, 0.8),
  lighten(uscaSecondaryBase, 0.7),
  lighten(uscaSecondaryBase, 0.6),
  lighten(uscaSecondaryBase, 0.5),
  lighten(uscaSecondaryBase, 0.4),
  lighten(uscaSecondaryBase, 0.3),
  lighten(uscaSecondaryBase, 0.2),
  lighten(uscaSecondaryBase, 0.1),
  uscaSecondaryBase,
];

export const arizonaEllerPrimaryBase = "#0C234B";
export const arizonaEllerPrimary: MantineColorsTuple = [
  lighten(arizonaEllerPrimaryBase, 0.9),
  lighten(arizonaEllerPrimaryBase, 0.8),
  lighten(arizonaEllerPrimaryBase, 0.7),
  lighten(arizonaEllerPrimaryBase, 0.6),
  lighten(arizonaEllerPrimaryBase, 0.5),
  lighten(arizonaEllerPrimaryBase, 0.4),
  lighten(arizonaEllerPrimaryBase, 0.3),
  lighten(arizonaEllerPrimaryBase, 0.2),
  lighten(arizonaEllerPrimaryBase, 0.1),
  arizonaEllerPrimaryBase,
];

export const arizonaEllerSecondaryBase = "#AB0520";
export const arizonaEllerSecondary: MantineColorsTuple = [
  lighten(arizonaEllerSecondaryBase, 0.9),
  lighten(arizonaEllerSecondaryBase, 0.8),
  lighten(arizonaEllerSecondaryBase, 0.7),
  lighten(arizonaEllerSecondaryBase, 0.6),
  lighten(arizonaEllerSecondaryBase, 0.5),
  lighten(arizonaEllerSecondaryBase, 0.4),
  lighten(arizonaEllerSecondaryBase, 0.3),
  lighten(arizonaEllerSecondaryBase, 0.2),
  lighten(arizonaEllerSecondaryBase, 0.1),
  arizonaEllerSecondaryBase,
];

export const purduePrimaryBase = "#000000";
export const purduePrimary: MantineColorsTuple = [
  lighten(purduePrimaryBase, 0.9),
  lighten(purduePrimaryBase, 0.8),
  lighten(purduePrimaryBase, 0.7),
  lighten(purduePrimaryBase, 0.6),
  lighten(purduePrimaryBase, 0.5),
  lighten(purduePrimaryBase, 0.4),
  lighten(purduePrimaryBase, 0.3),
  lighten(purduePrimaryBase, 0.2),
  lighten(purduePrimaryBase, 0.1),
  purduePrimaryBase,
];

export const purdueSecondaryBase = "#CFB991";
export const purdueSecondary: MantineColorsTuple = [
  lighten(purdueSecondaryBase, 0.9),
  lighten(purdueSecondaryBase, 0.8),
  lighten(purdueSecondaryBase, 0.7),
  lighten(purdueSecondaryBase, 0.6),
  lighten(purdueSecondaryBase, 0.5),
  lighten(purdueSecondaryBase, 0.4),
  lighten(purdueSecondaryBase, 0.3),
  lighten(purdueSecondaryBase, 0.2),
  lighten(purdueSecondaryBase, 0.1),
  purdueSecondaryBase,
];

export const uvaDardenPrimaryBase = "#232D4B";
export const uvaDardenPrimary: MantineColorsTuple = [
  lighten(uvaDardenPrimaryBase, 0.9),
  lighten(uvaDardenPrimaryBase, 0.8),
  lighten(uvaDardenPrimaryBase, 0.7),
  lighten(uvaDardenPrimaryBase, 0.6),
  lighten(uvaDardenPrimaryBase, 0.5),
  lighten(uvaDardenPrimaryBase, 0.4),
  lighten(uvaDardenPrimaryBase, 0.3),
  lighten(uvaDardenPrimaryBase, 0.2),
  lighten(uvaDardenPrimaryBase, 0.1),
  uvaDardenPrimaryBase,
];

export const uvaDardenSecondaryBase = "#E57200";
export const uvaDardenSecondary: MantineColorsTuple = [
  lighten(uvaDardenSecondaryBase, 0.9),
  lighten(uvaDardenSecondaryBase, 0.8),
  lighten(uvaDardenSecondaryBase, 0.7),
  lighten(uvaDardenSecondaryBase, 0.6),
  lighten(uvaDardenSecondaryBase, 0.5),
  lighten(uvaDardenSecondaryBase, 0.4),
  lighten(uvaDardenSecondaryBase, 0.3),
  lighten(uvaDardenSecondaryBase, 0.2),
  lighten(uvaDardenSecondaryBase, 0.1),
  uvaDardenSecondaryBase,
];

export const sierraCollegePrimaryBase = "#AF2124";
export const sierraCollegePrimary: MantineColorsTuple = [
  lighten(sierraCollegePrimaryBase, 0.9),
  lighten(sierraCollegePrimaryBase, 0.8),
  lighten(sierraCollegePrimaryBase, 0.7),
  lighten(sierraCollegePrimaryBase, 0.6),
  lighten(sierraCollegePrimaryBase, 0.5),
  lighten(sierraCollegePrimaryBase, 0.4),
  lighten(sierraCollegePrimaryBase, 0.3),
  lighten(sierraCollegePrimaryBase, 0.2),
  lighten(sierraCollegePrimaryBase, 0.1),
  sierraCollegePrimaryBase,
];

export const sierraCollegeSecondaryBase = "#9D9D9D";
export const sierraCollegeSecondary: MantineColorsTuple = [
  lighten(sierraCollegeSecondaryBase, 0.9),
  lighten(sierraCollegeSecondaryBase, 0.8),
  lighten(sierraCollegeSecondaryBase, 0.7),
  lighten(sierraCollegeSecondaryBase, 0.6),
  lighten(sierraCollegeSecondaryBase, 0.5),
  lighten(sierraCollegeSecondaryBase, 0.4),
  lighten(sierraCollegeSecondaryBase, 0.3),
  lighten(sierraCollegeSecondaryBase, 0.2),
  lighten(sierraCollegeSecondaryBase, 0.1),
  sierraCollegeSecondaryBase,
];

export const jessupUniversityPrimaryBase = "#0f2c47";
export const jessupUniversityPrimary: MantineColorsTuple = [
  lighten(jessupUniversityPrimaryBase, 0.9),
  lighten(jessupUniversityPrimaryBase, 0.8),
  lighten(jessupUniversityPrimaryBase, 0.7),
  lighten(jessupUniversityPrimaryBase, 0.6),
  lighten(jessupUniversityPrimaryBase, 0.5),
  lighten(jessupUniversityPrimaryBase, 0.4),
  lighten(jessupUniversityPrimaryBase, 0.3),
  lighten(jessupUniversityPrimaryBase, 0.2),
  lighten(jessupUniversityPrimaryBase, 0.1),
  jessupUniversityPrimaryBase,
];

export const jessupUniversitySecondaryBase = "#00addb";
export const jessupUniversitySecondary: MantineColorsTuple = [
  lighten(jessupUniversitySecondaryBase, 0.9),
  lighten(jessupUniversitySecondaryBase, 0.8),
  lighten(jessupUniversitySecondaryBase, 0.7),
  lighten(jessupUniversitySecondaryBase, 0.6),
  lighten(jessupUniversitySecondaryBase, 0.5),
  lighten(jessupUniversitySecondaryBase, 0.4),
  lighten(jessupUniversitySecondaryBase, 0.3),
  lighten(jessupUniversitySecondaryBase, 0.2),
  lighten(jessupUniversitySecondaryBase, 0.1),
  jessupUniversitySecondaryBase,
];

export const pbaPrimaryBase = "#0c2340";
export const pbaPrimary: MantineColorsTuple = [
  lighten(pbaPrimaryBase, 0.9),
  lighten(pbaPrimaryBase, 0.8),
  lighten(pbaPrimaryBase, 0.7),
  lighten(pbaPrimaryBase, 0.6),
  lighten(pbaPrimaryBase, 0.5),
  lighten(pbaPrimaryBase, 0.4),
  lighten(pbaPrimaryBase, 0.3),
  lighten(pbaPrimaryBase, 0.2),
  lighten(pbaPrimaryBase, 0.1),
  pbaPrimaryBase,
];

export const pbaSecondaryBase = "#04d3df";
export const pbaSecondary: MantineColorsTuple = [
  lighten(pbaSecondaryBase, 0.9),
  lighten(pbaSecondaryBase, 0.8),
  lighten(pbaSecondaryBase, 0.7),
  lighten(pbaSecondaryBase, 0.6),
  lighten(pbaSecondaryBase, 0.5),
  lighten(pbaSecondaryBase, 0.4),
  lighten(pbaSecondaryBase, 0.3),
  lighten(pbaSecondaryBase, 0.2),
  lighten(pbaSecondaryBase, 0.1),
  pbaSecondaryBase,
];

export const calStateLongBeachPrimaryBase = "#ffc72a";
export const calStateLongBeachPrimary: MantineColorsTuple = [
  lighten(calStateLongBeachPrimaryBase, 0.9),
  lighten(calStateLongBeachPrimaryBase, 0.8),
  lighten(calStateLongBeachPrimaryBase, 0.7),
  lighten(calStateLongBeachPrimaryBase, 0.6),
  lighten(calStateLongBeachPrimaryBase, 0.5),
  lighten(calStateLongBeachPrimaryBase, 0.4),
  lighten(calStateLongBeachPrimaryBase, 0.3),
  lighten(calStateLongBeachPrimaryBase, 0.2),
  lighten(calStateLongBeachPrimaryBase, 0.1),
  calStateLongBeachPrimaryBase,
];

export const calStateLongBeachSecondaryBase = "#000000";
export const calStateLongBeachSecondary: MantineColorsTuple = [
  lighten(calStateLongBeachSecondaryBase, 0.9),
  lighten(calStateLongBeachSecondaryBase, 0.8),
  lighten(calStateLongBeachSecondaryBase, 0.7),
  lighten(calStateLongBeachSecondaryBase, 0.6),
  lighten(calStateLongBeachSecondaryBase, 0.5),
  lighten(calStateLongBeachSecondaryBase, 0.4),
  lighten(calStateLongBeachSecondaryBase, 0.3),
  lighten(calStateLongBeachSecondaryBase, 0.2),
  lighten(calStateLongBeachSecondaryBase, 0.1),
  calStateLongBeachSecondaryBase,
];

export const lawhubPrimaryBase = "#001a30";
export const lawhubPrimary: MantineColorsTuple = [
  lighten(lawhubPrimaryBase, 0.9),
  lighten(lawhubPrimaryBase, 0.8),
  lighten(lawhubPrimaryBase, 0.7),
  lighten(lawhubPrimaryBase, 0.6),
  lighten(lawhubPrimaryBase, 0.5),
  lighten(lawhubPrimaryBase, 0.4),
  lighten(lawhubPrimaryBase, 0.3),
  lighten(lawhubPrimaryBase, 0.2),
  lighten(lawhubPrimaryBase, 0.1),
  lawhubPrimaryBase,
];

export const lawhubSecondaryBase = "#d73e1e";
export const lawhubSecondary: MantineColorsTuple = [
  lighten(lawhubSecondaryBase, 0.9),
  lighten(lawhubSecondaryBase, 0.8),
  lighten(lawhubSecondaryBase, 0.7),
  lighten(lawhubSecondaryBase, 0.6),
  lighten(lawhubSecondaryBase, 0.5),
  lighten(lawhubSecondaryBase, 0.4),
  lighten(lawhubSecondaryBase, 0.3),
  lighten(lawhubSecondaryBase, 0.2),
  lighten(lawhubSecondaryBase, 0.1),
  lawhubSecondaryBase,
];

export const cwuPrimaryBase = "#A30F32";
export const cwuPrimary: MantineColorsTuple = [
  lighten(cwuPrimaryBase, 0.9),
  lighten(cwuPrimaryBase, 0.8),
  lighten(cwuPrimaryBase, 0.7),
  lighten(cwuPrimaryBase, 0.6),
  lighten(cwuPrimaryBase, 0.5),
  lighten(cwuPrimaryBase, 0.4),
  lighten(cwuPrimaryBase, 0.3),
  lighten(cwuPrimaryBase, 0.2),
  lighten(cwuPrimaryBase, 0.1),
  cwuPrimaryBase,
];

export const cwuSecondaryBase = "#000000";
export const cwuSecondary: MantineColorsTuple = [
  lighten(cwuSecondaryBase, 0.9),
  lighten(cwuSecondaryBase, 0.8),
  lighten(cwuSecondaryBase, 0.7),
  lighten(cwuSecondaryBase, 0.6),
  lighten(cwuSecondaryBase, 0.5),
  lighten(cwuSecondaryBase, 0.4),
  lighten(cwuSecondaryBase, 0.3),
  lighten(cwuSecondaryBase, 0.2),
  lighten(cwuSecondaryBase, 0.1),
  cwuSecondaryBase,
];

export const smuPrimaryBase = "#354CA1";
export const smuPrimary: MantineColorsTuple = [
  lighten(smuPrimaryBase, 0.9),
  lighten(smuPrimaryBase, 0.8),
  lighten(smuPrimaryBase, 0.7),
  lighten(smuPrimaryBase, 0.6),
  lighten(smuPrimaryBase, 0.5),
  lighten(smuPrimaryBase, 0.4),
  lighten(smuPrimaryBase, 0.3),
  lighten(smuPrimaryBase, 0.2),
  lighten(smuPrimaryBase, 0.1),
  smuPrimaryBase,
];

export const smuSecondaryBase = "#CC0035";
export const smuSecondary: MantineColorsTuple = [
  lighten(smuSecondaryBase, 0.9),
  lighten(smuSecondaryBase, 0.8),
  lighten(smuSecondaryBase, 0.7),
  lighten(smuSecondaryBase, 0.6),
  lighten(smuSecondaryBase, 0.5),
  lighten(smuSecondaryBase, 0.4),
  lighten(smuSecondaryBase, 0.3),
  lighten(smuSecondaryBase, 0.2),
  lighten(smuSecondaryBase, 0.1),
  smuSecondaryBase,
];

export const wbuPrimaryBase = "#084a8e";
export const wbuPrimary: MantineColorsTuple = [
  lighten(wbuPrimaryBase, 0.9),
  lighten(wbuPrimaryBase, 0.8),
  lighten(wbuPrimaryBase, 0.7),
  lighten(wbuPrimaryBase, 0.6),
  lighten(wbuPrimaryBase, 0.5),
  lighten(wbuPrimaryBase, 0.4),
  lighten(wbuPrimaryBase, 0.3),
  lighten(wbuPrimaryBase, 0.2),
  lighten(wbuPrimaryBase, 0.1),
  wbuPrimaryBase,
];

export const wbuSecondaryBase = "#eec301";
export const wbuSecondary: MantineColorsTuple = [
  lighten(wbuSecondaryBase, 0.9),
  lighten(wbuSecondaryBase, 0.8),
  lighten(wbuSecondaryBase, 0.7),
  lighten(wbuSecondaryBase, 0.6),
  lighten(wbuSecondaryBase, 0.5),
  lighten(wbuSecondaryBase, 0.4),
  lighten(wbuSecondaryBase, 0.3),
  lighten(wbuSecondaryBase, 0.2),
  lighten(wbuSecondaryBase, 0.1),
  wbuSecondaryBase,
];

export const utkHaslamPrimaryBase = "#FF8200";
export const utkHaslamPrimary: MantineColorsTuple = [
  lighten(utkHaslamPrimaryBase, 0.9),
  lighten(utkHaslamPrimaryBase, 0.8),
  lighten(utkHaslamPrimaryBase, 0.7),
  lighten(utkHaslamPrimaryBase, 0.6),
  lighten(utkHaslamPrimaryBase, 0.5),
  lighten(utkHaslamPrimaryBase, 0.4),
  lighten(utkHaslamPrimaryBase, 0.3),
  lighten(utkHaslamPrimaryBase, 0.2),
  lighten(utkHaslamPrimaryBase, 0.1),
  utkHaslamPrimaryBase,
];

export const utkHaslamSecondaryBase = "#FFFFFF";
export const utkHaslamSecondary: MantineColorsTuple = [
  lighten(utkHaslamSecondaryBase, 0.9),
  lighten(utkHaslamSecondaryBase, 0.8),
  lighten(utkHaslamSecondaryBase, 0.7),
  lighten(utkHaslamSecondaryBase, 0.6),
  lighten(utkHaslamSecondaryBase, 0.5),
  lighten(utkHaslamSecondaryBase, 0.4),
  lighten(utkHaslamSecondaryBase, 0.3),
  lighten(utkHaslamSecondaryBase, 0.2),
  lighten(utkHaslamSecondaryBase, 0.1),
  utkHaslamSecondaryBase,
];

export const unlvPrimaryBase = "#B10202";
export const unlvPrimary: MantineColorsTuple = [
  lighten(unlvPrimaryBase, 0.9),
  lighten(unlvPrimaryBase, 0.8),
  lighten(unlvPrimaryBase, 0.7),
  lighten(unlvPrimaryBase, 0.6),
  lighten(unlvPrimaryBase, 0.5),
  lighten(unlvPrimaryBase, 0.4),
  lighten(unlvPrimaryBase, 0.3),
  lighten(unlvPrimaryBase, 0.2),
  lighten(unlvPrimaryBase, 0.1),
  unlvPrimaryBase,
];

export const unlvSecondaryBase = "#666666";
export const unlvSecondary: MantineColorsTuple = [
  lighten(unlvSecondaryBase, 0.9),
  lighten(unlvSecondaryBase, 0.8),
  lighten(unlvSecondaryBase, 0.7),
  lighten(unlvSecondaryBase, 0.6),
  lighten(unlvSecondaryBase, 0.5),
  lighten(unlvSecondaryBase, 0.4),
  lighten(unlvSecondaryBase, 0.3),
  lighten(unlvSecondaryBase, 0.2),
  lighten(unlvSecondaryBase, 0.1),
  unlvSecondaryBase,
];

export const foreseeableFuturesPrimaryBase = "#79cba7";
export const foreseeableFuturesPrimary: MantineColorsTuple = [
  lighten(foreseeableFuturesPrimaryBase, 0.9),
  lighten(foreseeableFuturesPrimaryBase, 0.8),
  lighten(foreseeableFuturesPrimaryBase, 0.7),
  lighten(foreseeableFuturesPrimaryBase, 0.6),
  lighten(foreseeableFuturesPrimaryBase, 0.5),
  lighten(foreseeableFuturesPrimaryBase, 0.4),
  lighten(foreseeableFuturesPrimaryBase, 0.3),
  lighten(foreseeableFuturesPrimaryBase, 0.2),
  lighten(foreseeableFuturesPrimaryBase, 0.1),
  foreseeableFuturesPrimaryBase,
];

export const foreseeableFuturesSecondaryBase = "#29664b";
export const foreseeableFuturesSecondary: MantineColorsTuple = [
  lighten(foreseeableFuturesSecondaryBase, 0.9),
  lighten(foreseeableFuturesSecondaryBase, 0.8),
  lighten(foreseeableFuturesSecondaryBase, 0.7),
  lighten(foreseeableFuturesSecondaryBase, 0.6),
  lighten(foreseeableFuturesSecondaryBase, 0.5),
  lighten(foreseeableFuturesSecondaryBase, 0.4),
  lighten(foreseeableFuturesSecondaryBase, 0.3),
  lighten(foreseeableFuturesSecondaryBase, 0.2),
  lighten(foreseeableFuturesSecondaryBase, 0.1),
  foreseeableFuturesSecondaryBase,
];

export const eagleAcademyFoundationPrimaryBase = "#85191E";
export const eagleAcademyFoundationPrimary: MantineColorsTuple = [
  lighten(eagleAcademyFoundationPrimaryBase, 0.9),
  lighten(eagleAcademyFoundationPrimaryBase, 0.8),
  lighten(eagleAcademyFoundationPrimaryBase, 0.7),
  lighten(eagleAcademyFoundationPrimaryBase, 0.6),
  lighten(eagleAcademyFoundationPrimaryBase, 0.5),
  lighten(eagleAcademyFoundationPrimaryBase, 0.4),
  lighten(eagleAcademyFoundationPrimaryBase, 0.3),
  lighten(eagleAcademyFoundationPrimaryBase, 0.2),
  lighten(eagleAcademyFoundationPrimaryBase, 0.1),
  eagleAcademyFoundationPrimaryBase,
];

export const eagleAcademyFoundationSecondaryBase = "#333333";
export const eagleAcademyFoundationSecondary: MantineColorsTuple = [
  lighten(eagleAcademyFoundationSecondaryBase, 0.9),
  lighten(eagleAcademyFoundationSecondaryBase, 0.8),
  lighten(eagleAcademyFoundationSecondaryBase, 0.7),
  lighten(eagleAcademyFoundationSecondaryBase, 0.6),
  lighten(eagleAcademyFoundationSecondaryBase, 0.5),
  lighten(eagleAcademyFoundationSecondaryBase, 0.4),
  lighten(eagleAcademyFoundationSecondaryBase, 0.3),
  lighten(eagleAcademyFoundationSecondaryBase, 0.2),
  lighten(eagleAcademyFoundationSecondaryBase, 0.1),
  eagleAcademyFoundationSecondaryBase,
];

export const northshorePrimaryBase = "#1e3463";
export const northshorePrimary: MantineColorsTuple = [
  lighten(northshorePrimaryBase, 0.9),
  lighten(northshorePrimaryBase, 0.8),
  lighten(northshorePrimaryBase, 0.7),
  lighten(northshorePrimaryBase, 0.6),
  lighten(northshorePrimaryBase, 0.5),
  lighten(northshorePrimaryBase, 0.4),
  lighten(northshorePrimaryBase, 0.3),
  lighten(northshorePrimaryBase, 0.2),
  lighten(northshorePrimaryBase, 0.1),
  northshorePrimaryBase,
];

export const northshoreSecondaryBase = "#c1002a";
export const northshoreSecondary: MantineColorsTuple = [
  lighten(northshoreSecondaryBase, 0.9),
  lighten(northshoreSecondaryBase, 0.8),
  lighten(northshoreSecondaryBase, 0.7),
  lighten(northshoreSecondaryBase, 0.6),
  lighten(northshoreSecondaryBase, 0.5),
  lighten(northshoreSecondaryBase, 0.4),
  lighten(northshoreSecondaryBase, 0.3),
  lighten(northshoreSecondaryBase, 0.2),
  lighten(northshoreSecondaryBase, 0.1),
  northshoreSecondaryBase,
];

export const miamiPrimaryBase = "#005030";
export const miamiPrimary: MantineColorsTuple = [
  lighten(miamiPrimaryBase, 0.9),
  lighten(miamiPrimaryBase, 0.8),
  lighten(miamiPrimaryBase, 0.7),
  lighten(miamiPrimaryBase, 0.6),
  lighten(miamiPrimaryBase, 0.5),
  lighten(miamiPrimaryBase, 0.4),
  lighten(miamiPrimaryBase, 0.3),
  lighten(miamiPrimaryBase, 0.2),
  lighten(miamiPrimaryBase, 0.1),
  miamiPrimaryBase,
];

export const miamiSecondaryBase = "#f47321";
export const miamiSecondary: MantineColorsTuple = [
  lighten(miamiSecondaryBase, 0.9),
  lighten(miamiSecondaryBase, 0.8),
  lighten(miamiSecondaryBase, 0.7),
  lighten(miamiSecondaryBase, 0.6),
  lighten(miamiSecondaryBase, 0.5),
  lighten(miamiSecondaryBase, 0.4),
  lighten(miamiSecondaryBase, 0.3),
  lighten(miamiSecondaryBase, 0.2),
  lighten(miamiSecondaryBase, 0.1),
  miamiSecondaryBase,
];

export const pittPrimaryBase = "#003594";
export const pittPrimary: MantineColorsTuple = [
  lighten(pittPrimaryBase, 0.9),
  lighten(pittPrimaryBase, 0.8),
  lighten(pittPrimaryBase, 0.7),
  lighten(pittPrimaryBase, 0.6),
  lighten(pittPrimaryBase, 0.5),
  lighten(pittPrimaryBase, 0.4),
  lighten(pittPrimaryBase, 0.3),
  lighten(pittPrimaryBase, 0.2),
  lighten(pittPrimaryBase, 0.1),
  pittPrimaryBase,
];

export const pittSecondaryBase = "#FFB81C";
export const pittSecondary: MantineColorsTuple = [
  lighten(pittSecondaryBase, 0.9),
  lighten(pittSecondaryBase, 0.8),
  lighten(pittSecondaryBase, 0.7),
  lighten(pittSecondaryBase, 0.6),
  lighten(pittSecondaryBase, 0.5),
  lighten(pittSecondaryBase, 0.4),
  lighten(pittSecondaryBase, 0.3),
  lighten(pittSecondaryBase, 0.2),
  lighten(pittSecondaryBase, 0.1),
  pittSecondaryBase,
];

export const yorkCollegeCunyPrimaryBase = "#ef4035";
export const yorkCollegeCunyPrimary: MantineColorsTuple = [
  lighten(yorkCollegeCunyPrimaryBase, 0.9),
  lighten(yorkCollegeCunyPrimaryBase, 0.8),
  lighten(yorkCollegeCunyPrimaryBase, 0.7),
  lighten(yorkCollegeCunyPrimaryBase, 0.6),
  lighten(yorkCollegeCunyPrimaryBase, 0.5),
  lighten(yorkCollegeCunyPrimaryBase, 0.4),
  lighten(yorkCollegeCunyPrimaryBase, 0.3),
  lighten(yorkCollegeCunyPrimaryBase, 0.2),
  lighten(yorkCollegeCunyPrimaryBase, 0.1),
  yorkCollegeCunyPrimaryBase,
];

export const yorkCollegeCunySecondaryBase = "#6d6e71";
export const yorkCollegeCunySecondary: MantineColorsTuple = [
  lighten(yorkCollegeCunySecondaryBase, 0.9),
  lighten(yorkCollegeCunySecondaryBase, 0.8),
  lighten(yorkCollegeCunySecondaryBase, 0.7),
  lighten(yorkCollegeCunySecondaryBase, 0.6),
  lighten(yorkCollegeCunySecondaryBase, 0.5),
  lighten(yorkCollegeCunySecondaryBase, 0.4),
  lighten(yorkCollegeCunySecondaryBase, 0.3),
  lighten(yorkCollegeCunySecondaryBase, 0.2),
  lighten(yorkCollegeCunySecondaryBase, 0.1),
  yorkCollegeCunySecondaryBase,
];

export const pointLomaPrimaryBase = "#0E553F";
export const pointLomaPrimary: MantineColorsTuple = [
  lighten(pointLomaPrimaryBase, 0.9),
  lighten(pointLomaPrimaryBase, 0.8),
  lighten(pointLomaPrimaryBase, 0.7),
  lighten(pointLomaPrimaryBase, 0.6),
  lighten(pointLomaPrimaryBase, 0.5),
  lighten(pointLomaPrimaryBase, 0.4),
  lighten(pointLomaPrimaryBase, 0.3),
  lighten(pointLomaPrimaryBase, 0.2),
  lighten(pointLomaPrimaryBase, 0.1),
  pointLomaPrimaryBase,
];

export const pointLomaSecondaryBase = "#9B8542";
export const pointLomaSecondary: MantineColorsTuple = [
  lighten(pointLomaSecondaryBase, 0.9),
  lighten(pointLomaSecondaryBase, 0.8),
  lighten(pointLomaSecondaryBase, 0.7),
  lighten(pointLomaSecondaryBase, 0.6),
  lighten(pointLomaSecondaryBase, 0.5),
  lighten(pointLomaSecondaryBase, 0.4),
  lighten(pointLomaSecondaryBase, 0.3),
  lighten(pointLomaSecondaryBase, 0.2),
  lighten(pointLomaSecondaryBase, 0.1),
  pointLomaSecondaryBase,
];

export const ncStatePrimaryBase = "#CC0000";
export const ncStatePrimary: MantineColorsTuple = [
  lighten(ncStatePrimaryBase, 0.9),
  lighten(ncStatePrimaryBase, 0.8),
  lighten(ncStatePrimaryBase, 0.7),
  lighten(ncStatePrimaryBase, 0.6),
  lighten(ncStatePrimaryBase, 0.5),
  lighten(ncStatePrimaryBase, 0.4),
  lighten(ncStatePrimaryBase, 0.3),
  lighten(ncStatePrimaryBase, 0.2),
  lighten(ncStatePrimaryBase, 0.1),
  ncStatePrimaryBase,
];

export const ncStateSecondaryBase = "#000000";
export const ncStateSecondary: MantineColorsTuple = [
  lighten(ncStateSecondaryBase, 0.9),
  lighten(ncStateSecondaryBase, 0.8),
  lighten(ncStateSecondaryBase, 0.7),
  lighten(ncStateSecondaryBase, 0.6),
  lighten(ncStateSecondaryBase, 0.5),
  lighten(ncStateSecondaryBase, 0.4),
  lighten(ncStateSecondaryBase, 0.3),
  lighten(ncStateSecondaryBase, 0.2),
  lighten(ncStateSecondaryBase, 0.1),
  ncStateSecondaryBase,
];

export const scuPrimaryBase = "#A32035";
export const scuPrimary: MantineColorsTuple = [
  lighten(scuPrimaryBase, 0.9),
  lighten(scuPrimaryBase, 0.8),
  lighten(scuPrimaryBase, 0.7),
  lighten(scuPrimaryBase, 0.6),
  lighten(scuPrimaryBase, 0.5),
  lighten(scuPrimaryBase, 0.4),
  lighten(scuPrimaryBase, 0.3),
  lighten(scuPrimaryBase, 0.2),
  lighten(scuPrimaryBase, 0.1),
  scuPrimaryBase,
];

export const scuSecondaryBase = "#758592";
export const scuSecondary: MantineColorsTuple = [
  lighten(scuSecondaryBase, 0.9),
  lighten(scuSecondaryBase, 0.8),
  lighten(scuSecondaryBase, 0.7),
  lighten(scuSecondaryBase, 0.6),
  lighten(scuSecondaryBase, 0.5),
  lighten(scuSecondaryBase, 0.4),
  lighten(scuSecondaryBase, 0.3),
  lighten(scuSecondaryBase, 0.2),
  lighten(scuSecondaryBase, 0.1),
  scuSecondaryBase,
];

export const adobePrimaryBase = "#FF0000";
export const adobePrimary: MantineColorsTuple = [
  lighten(adobePrimaryBase, 0.9),
  lighten(adobePrimaryBase, 0.8),
  lighten(adobePrimaryBase, 0.7),
  lighten(adobePrimaryBase, 0.6),
  lighten(adobePrimaryBase, 0.5),
  lighten(adobePrimaryBase, 0.4),
  lighten(adobePrimaryBase, 0.3),
  lighten(adobePrimaryBase, 0.2),
  lighten(adobePrimaryBase, 0.1),
  adobePrimaryBase,
];

export const adobeSecondaryBase = "#ffffff";
export const adobeSecondary: MantineColorsTuple = [
  lighten(adobeSecondaryBase, 0.9),
  lighten(adobeSecondaryBase, 0.8),
  lighten(adobeSecondaryBase, 0.7),
  lighten(adobeSecondaryBase, 0.6),
  lighten(adobeSecondaryBase, 0.5),
  lighten(adobeSecondaryBase, 0.4),
  lighten(adobeSecondaryBase, 0.3),
  lighten(adobeSecondaryBase, 0.2),
  lighten(adobeSecondaryBase, 0.1),
  adobeSecondaryBase,
];

export const uscPrimaryBase = "#990000";
export const uscPrimary: MantineColorsTuple = [
  lighten(uscPrimaryBase, 0.9),
  lighten(uscPrimaryBase, 0.8),
  lighten(uscPrimaryBase, 0.7),
  lighten(uscPrimaryBase, 0.6),
  lighten(uscPrimaryBase, 0.5),
  lighten(uscPrimaryBase, 0.4),
  lighten(uscPrimaryBase, 0.3),
  lighten(uscPrimaryBase, 0.2),
  lighten(uscPrimaryBase, 0.1),
  uscPrimaryBase,
];

export const uscSecondaryBase = "#FFCC00";
export const uscSecondary: MantineColorsTuple = [
  lighten(uscSecondaryBase, 0.9),
  lighten(uscSecondaryBase, 0.8),
  lighten(uscSecondaryBase, 0.7),
  lighten(uscSecondaryBase, 0.6),
  lighten(uscSecondaryBase, 0.5),
  lighten(uscSecondaryBase, 0.4),
  lighten(uscSecondaryBase, 0.3),
  lighten(uscSecondaryBase, 0.2),
  lighten(uscSecondaryBase, 0.1),
  uscSecondaryBase,
];

export const chicagoBoothPrimaryBase = "#800000";
export const chicagoBoothPrimary: MantineColorsTuple = [
  lighten(chicagoBoothPrimaryBase, 0.9),
  lighten(chicagoBoothPrimaryBase, 0.8),
  lighten(chicagoBoothPrimaryBase, 0.7),
  lighten(chicagoBoothPrimaryBase, 0.6),
  lighten(chicagoBoothPrimaryBase, 0.5),
  lighten(chicagoBoothPrimaryBase, 0.4),
  lighten(chicagoBoothPrimaryBase, 0.3),
  lighten(chicagoBoothPrimaryBase, 0.2),
  lighten(chicagoBoothPrimaryBase, 0.1),
  chicagoBoothPrimaryBase,
];

export const chicagoBoothSecondaryBase = "#D9D9D9";
export const chicagoBoothSecondary: MantineColorsTuple = [
  lighten(chicagoBoothSecondaryBase, 0.9),
  lighten(chicagoBoothSecondaryBase, 0.8),
  lighten(chicagoBoothSecondaryBase, 0.7),
  lighten(chicagoBoothSecondaryBase, 0.6),
  lighten(chicagoBoothSecondaryBase, 0.5),
  lighten(chicagoBoothSecondaryBase, 0.4),
  lighten(chicagoBoothSecondaryBase, 0.3),
  lighten(chicagoBoothSecondaryBase, 0.2),
  lighten(chicagoBoothSecondaryBase, 0.1),
  chicagoBoothSecondaryBase,
];